export interface MenuItem {
  name: string;
  price: number | string;
  note?: string;
  category?: string;
}

export interface ClubVenue {
  id: string;
  name: string;
  kind: string;
  phone: string;
  hours: string;
  dress: string;
  about: string;
  items: MenuItem[];
}

export interface Clubhouse {
  id: string;
  name: string;
  address: string;
  phone: string;
  note: string;
  venues: ClubVenue[];
}

export const CLUBHOUSES: Clubhouse[] = [
  {
    id: 'arlington',
    name: 'Arlington Clubhouse',
    address: '1700 Army Navy Drive, Arlington, VA 22202',
    phone: '703-521-6800',
    note: 'Multiple dining rooms · Sun Room is business casual+; Grille and 1924 are casual.',
    venues: [
      {
        id: 'sunroom', name: 'Sun Room', kind: 'Formal · Prix Fixe', phone: '703-521-6800',
        hours: 'Tue–Sun · 5:30–9:00 PM', dress: 'Business casual or above',
        about: 'Formal dining with terrace seating and a seasonal prix fixe menu.',
        items: [
          { name: 'Prix Fixe (3 course)', price: 78, note: "Chef's selection" },
          { name: 'Chilean Sea Bass', price: 52 },
          { name: 'Filet Mignon · 8oz', price: 58 },
          { name: 'Crab Cake Entrée', price: 48 },
        ],
      },
      {
        id: 'grille', name: 'Grille', kind: 'Casual · Bar & Patio', phone: '703-521-6800',
        hours: 'Daily · 11:00 AM – 9:00 PM', dress: 'Casual attire',
        about: 'The go-to spot after a round.',
        items: [
          { name: 'ANCC Cheeseburger', price: 18 },
          { name: 'Texas Club Wrap', price: 17 },
          { name: 'Steak au Poivre', price: 36 },
          { name: 'Crab Cake Sandwich', price: 26 },
          { name: 'Wings · 10pc', price: 16 },
        ],
      },
      {
        id: '1924', name: '1924', kind: 'Dinner · Chef-Driven', phone: '703-521-6800',
        hours: 'Dinner Service', dress: 'Smart Casual',
        about: 'Chef-driven dinner: pasta, USDA Prime steaks, and signature pizzas.',
        items: [
          { category: 'From the Fire', name: '8oz Filet Mignon', price: 62, note: 'GF' },
          { category: 'From the Fire', name: '12oz New York Strip', price: 49, note: 'GF' },
          { category: 'Pizzas', name: 'Classic', price: 13 },
          { category: 'Handhelds', name: 'Five-Star Burger', price: 22 },
        ],
      },
      {
        id: 'starsandstripes', name: 'Stars and Stripes', kind: 'Lunch · Dinner', phone: '703-521-6800',
        hours: 'Daily · 11:00 AM – 8:45 PM', dress: 'Golf attire welcome',
        about: 'Casual lunch and dinner with burgers, salads, and plates.',
        items: [
          { name: 'S&S Burger', price: 16 },
          { name: 'Philly Cheesesteak', price: 16 },
          { name: 'Seared Salmon', price: 20 },
          { name: 'KBBQ Bowl', price: 24 },
        ],
      },
    ],
  },
  {
    id: 'fairfax',
    name: 'Fairfax Clubhouse',
    address: '3315 Blenheim Blvd, Fairfax, VA 22030',
    phone: '703-359-5825',
    note: 'Smaller, casual operation. Mixed Grille is the main dining room.',
    venues: [
      {
        id: 'mixed', name: 'Mixed Grille', kind: 'All-Day Dining', phone: '703-359-5825',
        hours: 'Daily · 11:00 AM – 8:30 PM', dress: 'Casual attire',
        about: 'All-day menu at Fairfax.',
        items: [
          { category: "Chef's Features", name: 'Atlantic Salmon', price: 29 },
          { category: "Chef's Features", name: 'Bistro Steak Frites', price: 28 },
          { category: 'Garden Treats', name: 'Cobb Salad', price: 13 },
          { category: 'Handhelds', name: 'Club Burger', price: 15 },
        ],
      },
    ],
  },
];
